import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import SearchAccountItemsPage from "../containers/SearchAccountItemsPage";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
});

class HomePageSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      searchError: "",
      notifyString: "",
      accounts: [],
      options: [],
      transitChange: false,
      selectedTransit: "",
      accountsForTransit: [],
      selectedAccount: {},
      scrubTimeLeft: 0,
    };
  }

  componentDidUpdate() {
    if (this.state.transitChange) {
      this.setState({ transitChange: false });
    }
  }

  componentDidMount() {
    this.props.prefs.secureToken = this.props.secureToken;
    fetch("on_home_page_reports_entry", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.props.prefs),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
        } else {
          this.setState({ accounts: reply.accounts });
          if (reply.accounts.length > 0) {
            this.setState({ selectedTransit: reply.accounts[0].transit });
            let accountsForTransit = reply.accounts[0].accountsData;
            this.setState({ accountsForTransit: accountsForTransit });
            this.setState({ selectedAccount: accountsForTransit[0] });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  handleTransitChange(e) {
    let accounts = this.state.accounts;
    let i;
    for (i = 0; i < accounts.length; i++) {
      if (accounts[i].transit === e.target.value) {
        this.setState({ selectedTransit: accounts[i].transit });
        let accountsForTransit = accounts[i].accountsData;
        this.setState({ accountsForTransit: accountsForTransit });
        this.setState({ selectedAccount: accountsForTransit[0] });
        break;
      }
    }
    this.setState({ transitChange: true });
  }

  handleAccountChange(e) {
    let accountNum = e.target.value;
    let i;
    for (i = 0; i < this.state.accountsForTransit.length; i++) {
      if (accountNum === this.state.accountsForTransit[i].account) {
        this.setState({ selectedAccount: this.state.accountsForTransit[i] });
        break;
      }
    }
    this.setState({ transitChange: true });
  }

  render() {
    let transits = this.state.accounts;
    let accountsForTransit = this.state.accountsForTransit;
    let { t } = this.props;
    return (
      <div style={{ margin: 20 }}>
        {this.state.errorString.length > 0 && (
          <Typography color="error" variant="title">
            &nbsp;&nbsp;{this.state.errorString}
          </Typography>
        )}
        {this.state.accounts.length > 0 && !this.state.transitChange && (
          <div style={{ margin: 20 }}>
            <Typography variant="body1" color="primary">
              {t("transit.label")}&nbsp;
              <NativeSelect
                style={{ height: 24, verticalAlign: "textTop", margin: 0 }}
                defaultValue={this.state.selectedTransit}
                input={<Input id="transit" />}
                onChange={(event) => this.handleTransitChange(event)}
              >
                {transits.map((n) => {
                  return <option value={n.transit}>{n.transit}</option>;
                })}
              </NativeSelect>
              &nbsp;&nbsp;{t("account.label")}&nbsp;
              <NativeSelect
                style={{ height: 24, verticalAlign: "textTop", margin: 0 }}
                defaultValue={this.state.selectedAccount.account}
                input={<Input id="account" />}
                onChange={(event) => this.handleAccountChange(event)}
              >
                {accountsForTransit.map((n) => {
                  return <option value={n.account}>{n.account}</option>;
                })}
              </NativeSelect>
            </Typography>
          </div>
        )}
        {this.state.notifyString.length > 0 && (
          <Typography color="primary" variant="subtitle1">
            &nbsp;&nbsp;{this.state.notifyString}
          </Typography>
        )}
        {this.state.searchError.length > 0 && (
          <Typography color="error" variant="title">
            &nbsp;&nbsp;{this.state.searchError}
          </Typography>
        )}
        <div>
          {this.state.accounts.length > 0 && !this.state.transitChange && (
            <SearchAccountItemsPage
              history={this.props.history}
              accountObject={this.state.selectedAccount}
              scrubTimeLeft={this.state.scrubTimeLeft}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(HomePageSearch));
